import { render, staticRenderFns } from "./DisasterPreventionInfoMap.vue?vue&type=template&id=116c0f84&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports